import * as m from "#/paraglide/messages";
import {
  createBackendFailureMessageResolver,
  readBackendFailure,
} from "#/shared/lib/backend-api";

import {
  getStoreConnectionOperation,
  type GetStoreConnectionOperation,
} from "../api/get-store-connection";

const resolveFailureMessage =
  createBackendFailureMessageResolver<GetStoreConnectionOperation>({
    forbidden: () => m.store_connection_failure_forbidden(),
    network: () => m.store_connection_failure_network(),
    rejected: () => m.store_connection_failure_rejected(),
    schema: () => m.store_connection_failure_schema(),
    unexpected: () => m.store_connection_failure_unexpected(),
  });

/**
 * 把读店铺接入信息时抛出的任意错误翻成一句可展示文案。
 * 不是本 feature 的失败时返回 null，界面据此保持安静。
 */
export function readStoreConnectionFailureMessage(
  error: unknown,
): string | null {
  return resolveFailureMessage(
    readBackendFailure(error, [getStoreConnectionOperation]),
  );
}
